/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import {
  set_value_insight,
  push_value_insight,
  get_insight_v2,
} from "../../App/actions/insight_v2";
import { is_pass_license_or_quota } from "../../App/actions/filter_license";

/*PICTURE*/
import ICON_ARROW_RIGHT_LINE from "../../Assets/jsx/ICON_ARROW_RIGHT_LINE";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
const language = localStorage?.language || "ina";

/*CONST*/
const array_level_tipe = [
  {
    key: "tipe_1",
    name: dict?.["General Category"]?.[language],
    description:
      dict?.["General category, example: EDUCATIONAL FACILITIES"]?.[language],
  },
  {
    key: "tipe_2",
    name: dict?.["Subcategory"]?.[language],
    description:
      dict?.[
        "Subcategory, example: elementary school, middle school, high school"
      ]?.[language],
  },
  {
    key: "tipe_3",
    name: dict?.["Specific Entity"]?.[language],
    description:
      dict?.["Examples: Indomaret, Alfamart, Dental Clinic"]?.[language],
  },
];

const SS_TIPE_POI = ({
  auth,
  insight_reducer,
  toggle_choose_poi,
  set_value_insight,
  push_value_insight,
}) => {
  const [state, setState] = useState({
    modal_tipe_2: false,
    tipe_1_opened: "",
    text_typing: "",
    text_filter: "",
    list_tipe_1_filtered_primer: [],
    list_tipe_1_filtered_sekunder: [],
    list_tipe_2_filtered_primer: [],
    list_tipe_2_filtered_sekunder: [],
    list_tipe_3_filtered_primer: [],
    list_tipe_3_filtered_sekunder: [],
  });

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const {
    text_typing,
    text_filter,
    list_tipe_2_filtered_primer,
    list_tipe_2_filtered_sekunder,
    list_tipe_3_filtered_primer,
    list_tipe_3_filtered_sekunder,
  } = state;

  //global props
  const {
    tipe_1_array,
    tipe_2_array,
    tipe_3_array,
    tipe_level,
    tipe_1_all,
    list_tipe_1,
    list_tipe_2,
    list_tipe_3,
  } = insight_reducer;
  let array_formula_insight = insight_reducer.array_formula_insight;

  const on_next = () => {
    toggle_choose_poi();
  };

  const on_change = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const on_enter_filter = (event) => {
    const { list_tipe_1, list_tipe_2, list_tipe_3 } = insight_reducer;
    event.preventDefault();
    const { text_typing } = state;
    setState((prevState) => ({ ...prevState, text_filter: text_typing }));

    setTimeout(() => {
      if (text_typing.length >= 3) {
        const { tipe_level } = insight_reducer;
        let primary_key, secondary_key, type_key, data_source;
        if (tipe_level === "tipe_3") {
          primary_key = "list_tipe_3_filtered_primer";
          secondary_key = "list_tipe_3_filtered_sekunder";
          type_key = "TIPE_3";
          data_source = list_tipe_3;
        } else if (tipe_level === "tipe_2") {
          primary_key = "list_tipe_2_filtered_primer";
          secondary_key = "list_tipe_2_filtered_sekunder";
          type_key = "TIPE_2";
          data_source = list_tipe_2;
        } else {
          primary_key = "list_tipe_1_filtered_primer";
          secondary_key = "list_tipe_1_filtered_sekunder";
          type_key = "TIPE_1";
          data_source = list_tipe_1;
        }
        const words = text_typing
          .split(" ")
          .filter((word) => word.length >= 3)
          .slice(0, 5);
        const strict_regex = new RegExp(
          words.map((word) => `\\b${word}`).join("|"),
          "i"
        );
        const broad_patterns = words.flatMap((word) => {
          const chunks = [];
          for (let i = 0; i <= word.length - 2; i++) {
            chunks.push(word.substring(i, i + 2));
            if (i <= word.length - 3) chunks.push(word.substring(i, i + 3));
          }
          return chunks;
        });
        const broad_regex = new RegExp(broad_patterns.join("|"), "i");
        const list_filtered_primary = data_source.filter((item) =>
          strict_regex.test(item[type_key])
        );
        const list_filtered_secondary = data_source.filter(
          (item) =>
            broad_regex.test(item[type_key]) &&
            !list_filtered_primary.includes(item)
        );
        setState((prevState) => ({
          ...prevState,
          [primary_key]: list_filtered_primary,
          [secondary_key]: list_filtered_secondary,
          text_typing: "",
        }));

        setTimeout(() => {
          const container = document.getElementById("section_2_insight_poi");
          if (container) container.scrollTo({ top: 0, behavior: "smooth" });
        }, 0);
      } else {
        setState((prevState) => ({
          ...prevState,
          list_tipe_1_filtered_primer: [],
          list_tipe_1_filtered_sekunder: [],
          list_tipe_2_filtered_primer: [],
          list_tipe_2_filtered_sekunder: [],
          list_tipe_3_filtered_primer: [],
          list_tipe_3_filtered_sekunder: [],
          text_typing: "",
        }));
        const container = document.getElementById("section_2_insight_poi");
        if (container) container.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 0);
  };

  const on_reset_filter = () => {
    setState((prevState) => ({ ...prevState, text_filter: "" }));
    const container = document.getElementById("section_2_insight_poi");
    if (container) container.scrollTo({ top: 0, behavior: "smooth" });
  };

  const on_toggle_tipe_1 = (item_1) => {
    const { list_tipe_2, list_tipe_3 } = insight_reducer;

    set_value_insight({ key: "tipe_1_all", value: false });
    const { tipe_1_array, tipe_2_array, tipe_3_array } = insight_reducer;
    const is_active = tipe_1_array.some(
      (element) => element.TIPE_1 === item_1.TIPE_1
    );
    if (!is_active) {
      push_value_insight({ key: "tipe_1_array", value: item_1 });
      const tipe_2_array_new = [
        ...tipe_2_array,
        ...list_tipe_2.filter((item_2) => item_2.TIPE_1 === item_1.TIPE_1),
      ];
      set_value_insight({
        key: "tipe_2_array",
        value: tipe_2_array_new,
      });
      const tipe_3_array_new = [
        ...tipe_3_array,
        ...list_tipe_3.filter((item_3) => item_3.TIPE_1 === item_1.TIPE_1),
      ];
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array_new,
      });
    } else {
      set_value_insight({
        key: "tipe_1_array",
        value: tipe_1_array.filter(
          (element) => element.TIPE_1 !== item_1.TIPE_1
        ),
      });
      set_value_insight({
        key: "tipe_2_array",
        value: tipe_2_array.filter((item_2) => item_2.TIPE_1 !== item_1.TIPE_1),
      });
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array.filter((item_3) => item_3.TIPE_1 !== item_1.TIPE_1),
      });
      const key = item_1.TIPE_1;
      array_formula_insight = array_formula_insight.filter(
        (formula) => formula.key !== key
      );
      set_value_insight({
        key: "array_formula_insight",
        value: array_formula_insight,
      });
    }
  };

  const on_toggle_tipe_2 = (item_2) => {
    const { list_tipe_3 } = insight_reducer;

    const { tipe_3_array, tipe_2_array, tipe_1_array } = insight_reducer;
    set_value_insight({ key: "tipe_1_all", value: false });
    const is_active = tipe_2_array.some(
      (element) =>
        element.TIPE_1 === item_2.TIPE_1 && element.TIPE_2 === item_2.TIPE_2
    );
    if (!is_active) {
      //push tipe 2
      push_value_insight({ key: "tipe_2_array", value: item_2 });
      //push tipe 3
      const tipe_3_array_new = [
        ...tipe_3_array,
        ...list_tipe_3.filter(
          (item_3) =>
            item_3.TIPE_1 === item_2.TIPE_1 && item_3.TIPE_2 === item_2.TIPE_2
        ),
      ];
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array_new,
      });
    } else {
      //pull tipe 2
      set_value_insight({
        key: "tipe_2_array",
        value: tipe_2_array.filter(
          (element) =>
            !(
              element.TIPE_1 === item_2.TIPE_1 &&
              element.TIPE_2 === item_2.TIPE_2
            )
        ),
      });
      //pull tipe 3
      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array.filter(
          (item_3) =>
            item_3.TIPE_1 !== item_2.TIPE_1 && item_3.TIPE_2 !== item_2.TIPE_2
        ),
      });
      const key = item_2.TIPE_2 + ", " + item_2.TIPE_1;
      array_formula_insight = array_formula_insight.filter(
        (formula) => formula.key !== key
      );
      set_value_insight({
        key: "array_formula_insight",
        value: array_formula_insight,
      });
    }
    const TIPE_1 = item_2.TIPE_1;
    set_value_insight({
      key: "tipe_1_array",
      value: tipe_1_array.filter((element) => element.TIPE_1 !== TIPE_1),
    });
  };

  const on_toggle_tipe_3 = (item_3) => {
    const { tipe_3_array, tipe_1_array } = insight_reducer;
    set_value_insight({ key: "tipe_1_all", value: false });
    const is_active = tipe_3_array.some(
      (element) =>
        element.TIPE_1 === item_3.TIPE_1 &&
        element.TIPE_2 === item_3.TIPE_2 &&
        element.TIPE_3 === item_3.TIPE_3
    );
    if (!is_active) {
      push_value_insight({ key: "tipe_3_array", value: item_3 });
    } else {
      const key = item_3.TIPE_3 + ", " + item_3.TIPE_2 + ", " + item_3.TIPE_1;
      array_formula_insight = array_formula_insight.filter(
        (formula) => formula.key !== key
      );
      set_value_insight({
        key: "array_formula_insight",
        value: array_formula_insight,
      });

      set_value_insight({
        key: "tipe_3_array",
        value: tipe_3_array.filter(
          (element) =>
            !(
              element.TIPE_1 === item_3.TIPE_1 &&
              element.TIPE_2 === item_3.TIPE_2 &&
              element.TIPE_3 === item_3.TIPE_3
            )
        ),
      });
    }
    const TIPE_1 = item_3.TIPE_1;
    set_value_insight({
      key: "tipe_1_array",
      value: tipe_1_array.filter((element) => element.TIPE_1 !== TIPE_1),
    });
  };

  const toggle_tipe_1_all = () => {
    const { list_tipe_1, list_tipe_2, list_tipe_3 } = insight_reducer;
    const { tipe_1_all } = insight_reducer;
    set_value_insight({ key: "tipe_1_all", value: !tipe_1_all });
    set_value_insight({
      key: "tipe_1_array",
      value: tipe_1_all ? [] : list_tipe_1,
    });
    set_value_insight({
      key: "tipe_2_array",
      value: tipe_1_all ? [] : list_tipe_2,
    });
    set_value_insight({
      key: "tipe_3_array",
      value: tipe_1_all ? [] : list_tipe_3,
    });
  };

  const on_set_tipe_level = (tipe_level) => {
    const tipe_level_before = insight_reducer.tipe_level;

    if (tipe_level !== tipe_level_before) {
      let array_formula_insight = insight_reducer.array_formula_insight;
      array_formula_insight = array_formula_insight.filter(
        (item) => item.group !== "poi"
      );
      set_value_insight({
        key: "array_formula_insight",
        value: array_formula_insight,
      });
    }

    set_value_insight({ key: "tipe_level", value: tipe_level });
  };

  //content
  const tipe_3_content = text_filter ? (
    list_tipe_3_filtered_primer.length === 0 &&
    list_tipe_3_filtered_sekunder.length === 0 ? (
      <p>{dict?.["No result"]?.[language]}</p>
    ) : (
      <div>
        {list_tipe_3_filtered_primer.map((item_3, idx) => {
          const is_active = tipe_3_array.some(
            (element) =>
              element.TIPE_1 === item_3.TIPE_1 &&
              element.TIPE_2 === item_3.TIPE_2 &&
              element.TIPE_3 === item_3.TIPE_3
          );
          return (
            <div
              key={idx}
              className="container margin_right margin_bottom column_size_small background_grey_light outline_shadow_soft"
            >
              <div className="two_container_list">
                <button
                  className={`margin_right ${
                    is_active ? "checklist_active" : "checklist_not"
                  }`}
                  onClick={() => on_toggle_tipe_3(item_3)}
                />
                <p className="text_bold">{item_3.TIPE_3}</p>
              </div>
              <p className="button_small grey_container margin_top">
                {item_3.TIPE_2}
              </p>
            </div>
          );
        })}
        {list_tipe_3_filtered_sekunder.length > 0 && (
          <>
            <br />
            <br />
            <br />
            <br />
            {list_tipe_3_filtered_sekunder.map((item_3, idx) => {
              const is_active = tipe_3_array.some(
                (element) =>
                  element.TIPE_1 === item_3.TIPE_1 &&
                  element.TIPE_2 === item_3.TIPE_2 &&
                  element.TIPE_3 === item_3.TIPE_3
              );
              return (
                <div
                  key={idx}
                  className="container margin_right margin_bottom column_size_small  background_grey_light outline_shadow_soft"
                >
                  <div className="two_container_list">
                    <button
                      className={`margin_right ${
                        is_active ? "checklist_active" : "checklist_not"
                      }`}
                      onClick={() => on_toggle_tipe_3(item_3)}
                    />
                    <p className="text_bold">{item_3.TIPE_3}</p>
                  </div>
                  <p className="button_small grey_container margin_top">
                    {item_3.TIPE_2}
                  </p>
                </div>
              );
            })}
          </>
        )}
      </div>
    )
  ) : (
    <div>
      {list_tipe_1.map((item_1, idx) => {
        const is_active = tipe_1_array.some(
          (element) => element.TIPE_1 === item_1.TIPE_1
        );
        const list_tipe_3_filtered = list_tipe_3.filter(
          (item_tipe_3) => item_tipe_3.TIPE_1 === item_1.TIPE_1
        );
        return (
          <div key={idx}>
            <section className="two_container_list margin_bottom">
              <button
                className={`margin_right ${
                  is_active ? "checklist_active" : "checklist_not"
                }`}
                onClick={() => on_toggle_tipe_1(item_1)}
              />
              <p className="text_header">{item_1.TIPE_1}</p>
            </section>
            <br />
            {list_tipe_3_filtered.map((item_3, idx) => {
              const is_active = tipe_3_array.some(
                (element) =>
                  element.TIPE_1 === item_3.TIPE_1 &&
                  element.TIPE_2 === item_3.TIPE_2 &&
                  element.TIPE_3 === item_3.TIPE_3
              );
              return (
                <div
                  key={idx}
                  className="container margin_right margin_bottom column_size_small  background_grey_light outline_shadow_soft"
                >
                  <div className="two_container_list">
                    <button
                      className={`margin_right ${
                        is_active ? "checklist_active" : "checklist_not"
                      }`}
                      onClick={() => on_toggle_tipe_3(item_3)}
                    />
                    <p className="text_bold">{item_3.TIPE_3}</p>
                  </div>
                  <p className="button_small background_white margin_top">
                    {item_3.TIPE_2}
                  </p>
                </div>
              );
            })}
            <hr />
          </div>
        );
      })}
    </div>
  );

  const tipe_2_content = text_filter ? (
    list_tipe_2_filtered_primer.length === 0 &&
    list_tipe_2_filtered_sekunder.length === 0 ? (
      <p>No result</p>
    ) : (
      <div>
        {list_tipe_2_filtered_primer.map((item_2, idx) => {
          const is_active = tipe_2_array.some(
            (element) =>
              element.TIPE_1 === item_2.TIPE_1 &&
              element.TIPE_2 === item_2.TIPE_2
          );
          return (
            <div
              key={idx}
              className="container margin_right margin_bottom column_size_small background_grey_light outline_shadow_soft"
            >
              <div className="two_container_list">
                <button
                  className={`margin_right ${
                    is_active ? "checklist_active" : "checklist_not"
                  }`}
                  onClick={() => on_toggle_tipe_2(item_2)}
                />
                <p className="text_small">{item_2.TIPE_2}</p>
              </div>
            </div>
          );
        })}
        {list_tipe_2_filtered_sekunder.length > 0 && (
          <>
            <br />
            <br />
            <br />
            <br />
            {list_tipe_2_filtered_sekunder.map((item_2, idx) => {
              const is_active = tipe_2_array.some(
                (element) =>
                  element.TIPE_1 === item_2.TIPE_1 &&
                  element.TIPE_2 === item_2.TIPE_2
              );
              return (
                <div
                  key={idx}
                  className="container margin_right margin_bottom column_size_small background_grey_light outline_shadow_soft"
                >
                  <div className="two_container_list">
                    <button
                      className={`margin_right ${
                        is_active ? "checklist_active" : "checklist_not"
                      }`}
                      onClick={() => on_toggle_tipe_2(item_2)}
                    />
                    <p className="text_small">{item_2.TIPE_2}</p>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    )
  ) : (
    <div>
      {list_tipe_1.map((item_1, idx) => {
        const is_active = tipe_1_array.some(
          (element) => element.TIPE_1 === item_1.TIPE_1
        );
        const list_tipe_2_filtered = list_tipe_2.filter(
          (item_tipe_2) => item_tipe_2.TIPE_1 === item_1.TIPE_1
        );
        return (
          <div key={idx}>
            <section className="two_container_list margin_bottom">
              <button
                className={`margin_right ${
                  is_active ? "checklist_active" : "checklist_not"
                }`}
                onClick={() => on_toggle_tipe_1(item_1)}
              />
              <p className="text_bold">{item_1.TIPE_1}</p>
            </section>
            {list_tipe_2_filtered.map((item_2, idx) => {
              const is_active = tipe_2_array.some(
                (element) =>
                  element.TIPE_1 === item_2.TIPE_1 &&
                  element.TIPE_2 === item_2.TIPE_2
              );
              return (
                <div
                  key={idx}
                  className="container margin_right margin_bottom column_size_small background_grey_light outline_shadow_soft"
                >
                  <div className="two_container_list">
                    <button
                      className={`margin_right ${
                        is_active ? "checklist_active" : "checklist_not"
                      }`}
                      onClick={() => on_toggle_tipe_2(item_2)}
                    />
                    <p className="text_small">{item_2.TIPE_2}</p>
                  </div>
                </div>
              );
            })}
            <hr />
          </div>
        );
      })}
    </div>
  );

  return (
    <main className="parent_section" style={{ height: "100%" }}>
      <section className="section_1">
        <h1 className="text_bold margin_bottom">
          {dict?.["Select POI (Point of Interest) theme"]?.[language]}
        </h1>
        {array_level_tipe.map((item, idx) => (
          <section
            className="container margin_right margin_bottom grey_container outline_shadow_soft column_size_small"
            style={{ height: "100px" }}
            key={idx}
            onClick={() => on_set_tipe_level(item.key)}
          >
            <button
              className={`button outline_black ${
                tipe_level === item.key ? "background_black" : "button_white"
              }`}
            >
              {item.name}
            </button>
            <br />
            <br />
            <p className="text_small">{item.description}</p>
          </section>
        ))}

        <button
          className="button_pill_big button_white outline_black margin_bottom margin_right"
          onClick={on_next}
          data-mapid="clickNext"
        >
          <span className="badge_circle_big background_black margin_right">
            <ICON_ARROW_RIGHT_LINE fill="#fff" />
          </span>
          {dict?.["Next"]?.[language]}
        </button>

        <br />
        <br />

        {(tipe_level === "tipe_2" || tipe_level === "tipe_3") && (
          <div>
            <form onSubmit={on_enter_filter} className="inline">
              <input
                name="text_typing"
                value={text_typing}
                onChange={on_change}
                className="column_size_small margin_bottom margin_right"
                placeholder={dict?.["Search"]?.[language]}
              />
              <button
                type="submit"
                className="button_big background_black column_size_small margin_bottom margin_right"
              >
                {dict?.["Filter"]?.[language]}
              </button>
            </form>
            {text_filter && (
              <button className="badge_pill_big background_grey_light outline_shadow_soft inline">
                <span className="text_small margin_right">{text_filter}</span>
                <span
                  className="button_small background_black"
                  onClick={on_reset_filter}
                >
                  X
                </span>
              </button>
            )}
          </div>
        )}
      </section>

      <br />
      <br />

      <section className="section_2" id="section_2_insight_poi">
        <div className="container margin_right margin_bottom outline_grey background_white column_size_small">
          <section className="two_container_list">
            <button
              className={`margin_right ${
                tipe_1_all ? "checklist_active" : "checklist_not"
              }`}
              onClick={toggle_tipe_1_all}
              data-mapid="clickAll"
            />
            <p className="text_bold">{dict?.["All"]?.[language]}</p>
          </section>
        </div>
        {tipe_level === "tipe_1" ? (
          <div>
            {list_tipe_1.map((item, idx) => {
              const is_active = tipe_1_array.some(
                (element) => element.TIPE_1 === item.TIPE_1
              );
              return (
                <div key={idx}>
                  <div className="container margin_right margin_bottom column_size_medium background_grey_light outline_shadow_soft ">
                    <section className="two_container_list">
                      <button
                        className={`margin_right ${
                          is_active ? "checklist_active" : "checklist_not"
                        }`}
                        onClick={() => on_toggle_tipe_1(item)}
                        data-mapid={`tipe_1-${idx}`}
                      />
                      <p className="text_bold">{item.TIPE_1}</p>
                    </section>
                  </div>
                  <br />
                </div>
              );
            })}
          </div>
        ) : tipe_level === "tipe_2" ? (
          tipe_2_content
        ) : (
          tipe_3_content
        )}
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  map: state.map,
  properties: state.properties,
  insight_reducer: state.insight_reducer,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  set_value_insight,
  push_value_insight,
  get_insight_v2,
  is_pass_license_or_quota,
})(SS_TIPE_POI);
